<template>

  <div class="page">

    <div class="main">

      <div class="intro" @click="close">

        <div class="content">
          <!-- 我这里是循环向打字组件传值 -->
          <div class="title nodeItemShow" v-for="(v, k) in content" v-bind:key="k">
            {{ v }}
            <!-- <typewriter class="str" :str="v" @back="close"></typewriter> -->
          </div>
        </div>
        
      </div>

    </div>

    <div class="footer"></div>
    
  </div>

</template>

<script>
//设置时间，将words中的文字，逐条追加到content
// import LotteryPop from '@/components/common/lotteryPop.vue'
// import typewriter from '@/components/common/typewriter.vue'
export default {
  props: [],
  data() {
    return {
      content: [],
      str: "我是文字",
      words: [
        "因一次小小意外",
        "小黄人工厂流失大量不太乖能量",
        "为找回这些珍贵能量",
        "小黄人需要「不太乖星人」的帮助！",
        "在这里匹配你的不乖基因",
        "发挥想象力",
        "创作出属于你的不太乖现场",
        "你会是那个「不太乖星人」吗",
        "不安分的心已蠢蠢欲动",
        "那就冲吧？！",
      ]
    };
  },
  components: {
    // typewriter: typewriter
  },
  mounted() {
    // let _this = this
    // setTimeout(function(){
    //   _this.next();
    // },100000);
    this.setTime();
  },
  methods: {
    setTime() {
			var arr = this.words;
      var that = this;
      arr.forEach(function (v, k) {
        setTimeout(function () {
          that.content.push(v)
        }, k*500)
        // console.log(k)
        // this.next();
      })
      setTimeout(function() {
        that.$emit("close");
      },6000);
    },
    close() {
      this.$emit("close");
    }
  },
};
</script>

<style scoped lang="less">
.container {
  width: auto;
}
.paragraph {
  margin-bottom: 15px;
}
.nodeItem {
  opacity: 0;
}
.nodeItemShow {
  visibility: visible;
  animation: scan 1s ease 0s 1;
}
@keyframes scan {
  0% {
    opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

.page {
  height: 100vh;
  background: url("../images/bg2.jpg") left bottom no-repeat;
  background-size: 750px 1500px;
  position: relative;
  overflow: hidden;
}
.footer {
  width: 295px;
  height: 46px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 91px;
  margin: 0 auto;
  background: url("../images/icon-footer2.png") no-repeat;
  background-size: 100%;
}
.main {
  .loading {
    width: 323px;
    height: 431px;
    margin: 0 auto;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 40%;
    background: url("../images/bg/bg-loading.png") no-repeat;
    background-size: 100%;
  }
  .intro {
    width: 589px;
    height: 848px;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    margin-top: -424px;
    left: 0;
    right: 0;
    // bottom: 40%;
    background: url("../images/bg/bg-intro.png") no-repeat;
    background-size: 100%;
    .content {
      width: 390px;
      height: 410px;
      margin: 209px 103px 0;
      text-align: center;
      font-size: 22px;
      color: #ffda02;
      .title {
        line-height: 36px;
        &:nth-of-type(4) {
          margin-bottom: 40px;
        }
      }
    }
  }
}
</style>
